import {
  Col,
  Descriptions,
  Row,
  Typography,
} from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';
import ModalJSON from '../../components/ModalJSON';
import ModalObservaciones from '../../components/ModalObservaciones';

const ReadOnlyTabGeneral = ({
  credito,
  setCredito,
}) => {
  const { tiposDePersonas } = useSelector((state) => state.catalogs);

  return (
    <>
      <br />
      <Col span={24}>
        <Typography.Title level={4}>Padrón</Typography.Title>
      </Col>
      <Row justify="end">
        <Col>
          <ModalJSON json={credito?.datos_de_json_del_padron} label="padrón" />
        </Col>
        <Col>
          <ModalObservaciones
            remote
            formItemName="observaciones_del_padron"
            ejecucionId={credito?.id}
            callback={(observaciones_del_padron) => setCredito((prev) => ({
              ...prev,
              observaciones_del_padron,
            }))}
            label="Agregar observaciones al padrón"
          />
        </Col>
      </Row>
      <Col span={24}>
        <Descriptions
          layout="vertical"
          size="small"
          bordered
          column={{
            xs: 1, sm: 2, md: 3, lg: 4,
          }}
          labelStyle={{ fontWeight: 'bold' }}
        >
          <Descriptions.Item label="Padrón ID" span={1}>
            {credito?.object_id_padron || ' - '}
          </Descriptions.Item>
          <Descriptions.Item label="Clave del padrón" span={1}>
            {credito?.clave_del_padron || ' - '}
          </Descriptions.Item>
          <Descriptions.Item label="Clave principal del padrón" span={1}>
            {credito?.clave_principal_del_padron || ' - '}
          </Descriptions.Item>
          <Descriptions.Item label="Estatus del padrón" span={1}>
            {credito?.estatus_del_padron || ' - '}
          </Descriptions.Item>
          <Descriptions.Item label="Clave secundaria del padrón" span={1}>
            {credito?.clave_secundaria_del_padron || ' - '}
          </Descriptions.Item>
          <Descriptions.Item label="Nombres completos del padrón" span={4} contentStyle={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
            {credito?.nombres_completos_del_padron || ' - '}
          </Descriptions.Item>
          <Descriptions.Item label="Código postal del padrón" span={1}>
            {credito?.direccion_codigo_postal?.toUpperCase() || ' - '}
          </Descriptions.Item>
          <Descriptions.Item label="Correo electrónico del padrón" span={1}>
            {credito?.correo_electronico_del_padron || ' - '}
          </Descriptions.Item>
          <Descriptions.Item label="Teléfono del padrón" span={2}>
            {credito?.telefono_del_padron || ' - '}
          </Descriptions.Item>
          <Descriptions.Item label="Dirección del padrón" span={2} contentStyle={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
            {credito?.direccion_del_padron?.toUpperCase() || ' - '}
          </Descriptions.Item>
          <Descriptions.Item label="Dirección de notificación del padrón" span={2} contentStyle={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
            {credito?.direccion_de_notificacion_del_padron?.toUpperCase() || ' - '}
          </Descriptions.Item>
          {credito?.observaciones_del_padron && (
          <Descriptions.Item label="Observaciones" span={4} contentStyle={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
            {credito?.observaciones_del_padron || ' - '}
          </Descriptions.Item>
          )}
        </Descriptions>
      </Col>
      <br />
      <Col span={24}>
        <Typography.Title level={4}>Contribuyente</Typography.Title>
      </Col>
      <Row justify="end">
        <Col>
          <ModalJSON json={credito?.datos_del_contribuyente_json} label="contribuyente" />
        </Col>
        <Col>
          <ModalObservaciones
            remote
            formItemName="observaciones_del_contribuyente"
            ejecucionId={credito?.id}
            callback={(observaciones_del_contribuyente) => setCredito((prev) => ({
              ...prev,
              observaciones_del_contribuyente,
            }))}
            label="Agregar observaciones al contribuyente"
          />
        </Col>
      </Row>
      <Col span={24}>
        <Descriptions
          layout="vertical"
          size="small"
          bordered
          column={{
            xs: 1, sm: 2, md: 3, lg: 5,
          }}
          labelStyle={{ fontWeight: 'bold' }}
        >
          <Descriptions.Item label="ID del contribuyente" span={1}>
            {credito?.contribuyente || ' - '}
          </Descriptions.Item>
          <Descriptions.Item label="Clave del contribuyente" span={1}>
            {credito?.clave_del_contribuyente || ' - '}
          </Descriptions.Item>
          <Descriptions.Item label="Tipo de persona">
            {tiposDePersonas
              .find((tipo) => tipo.id === credito?.tipo_de_persona)?.descripcion || ' - '}
          </Descriptions.Item>
          <Descriptions.Item label="Nombre / Razón Social" contentStyle={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
            {credito?.nombre_completo_del_contribuyente || ' - '}
          </Descriptions.Item>
          <Descriptions.Item label="Estatus del contribuyente" span={1}>
            {credito?.estatus_del_contribuyente || ' - '}
          </Descriptions.Item>
          <Descriptions.Item label="RFC">
            {credito?.rfc_del_contribuyente || ' - '}
          </Descriptions.Item>
          <Descriptions.Item label="CURP">
            {credito?.curp_del_contribuyente || ' - '}
          </Descriptions.Item>
          <Descriptions.Item label="Fecha de constitución">
            {credito?.fecha_de_constitucion || ' - '}
          </Descriptions.Item>
          <Descriptions.Item label="Dirección" span={2} contentStyle={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
            {credito?.direccion_del_contribuyente?.toUpperCase() || ' - '}
          </Descriptions.Item>
          <Descriptions.Item label="Correo electrónico" span={1}>
            {credito?.correo_electronico_del_contribuyente || ' - '}
          </Descriptions.Item>
          <Descriptions.Item label="Dirección de notificación" contentStyle={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
            {credito?.direccion_de_notificacion_del_contribuyente?.toUpperCase() || ' - '}
          </Descriptions.Item>
          {credito?.observaciones_del_contribuyente && (
          <Descriptions.Item label="Observaciones" span={4} contentStyle={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
            {credito?.observaciones_del_contribuyente || ' - '}
          </Descriptions.Item>
          )}
        </Descriptions>
      </Col>
    </>
  );
};

export default ReadOnlyTabGeneral;

ReadOnlyTabGeneral.propTypes = {
  credito: PropTypes.shape({
    id: PropTypes.number.isRequired,
    folio: PropTypes.string.isRequired,
    origen_del_credito: PropTypes.number.isRequired,
    fecha_de_creacion: PropTypes.string.isRequired,
    estatus_credito: PropTypes.string.isRequired,
    datos_del_contribuyente_json: PropTypes.shape({}),
    datos_de_json_del_padron: PropTypes.shape({}),
    clave_del_padron: PropTypes.string.isRequired,
    clave_principal_del_padron: PropTypes.string.isRequired,
    clave_secundaria_del_padron: PropTypes.string.isRequired,
    nombres_completos_del_padron: PropTypes.string.isRequired,
    telefono_del_padron: PropTypes.string.isRequired,
    estatus_del_padron: PropTypes.string.isRequired,
    direccion_codigo_postal: PropTypes.string.isRequired,
    direccion_del_padron: PropTypes.string.isRequired,
    object_id_padron: PropTypes.string.isRequired,
    correo_electronico_del_padron: PropTypes.string.isRequired,
    direccion_de_notificacion_del_padron: PropTypes.string.isRequired,
    observaciones_del_padron: PropTypes.string.isRequired,
    observaciones_del_contribuyente: PropTypes.string.isRequired,
    rfc_del_contribuyente: PropTypes.string.isRequired,
    curp_del_contribuyente: PropTypes.string.isRequired,
    fecha_de_constitucion: PropTypes.string.isRequired,
    lugar_de_constitucion: PropTypes.string.isRequired,
    direccion_del_contribuyente: PropTypes.string.isRequired,
    correo_electronico_del_contribuyente: PropTypes.string.isRequired,
    direccion_de_notificacion_del_contribuyente: PropTypes.string.isRequired,
    actuacion: PropTypes.string.isRequired,
    clave_del_contribuyente: PropTypes.string.isRequired,
    nombre_completo_del_contribuyente: PropTypes.string.isRequired,
    apellido_paterno_del_contribuyente: PropTypes.string.isRequired,
    apellido_materno_del_contribuyente: PropTypes.string.isRequired,
    id_del_contribuyente: PropTypes.string.isRequired,
    tipo_de_persona: PropTypes.string.isRequired,
    estatus_del_contribuyente: PropTypes.string.isRequired,
    contribuyente: PropTypes.string.isRequired,
    estados_de_ejecucion: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
      descripcion: PropTypes.string.isRequired,
      actuacion: PropTypes.string.isRequired,
      fecha_de_creacion: PropTypes.string.isRequired,
    })).isRequired,
  }).isRequired,
  setCredito: PropTypes.func.isRequired,
};
